<template>
    <div class="content container-fluid">
        <h1>{{ item.nadpis_id ? 'Edycja' : 'Dodawanie' }} nadpisu</h1>
        <form @submit.prevent="save" class="text-start">
            <div class="form-nadpis mb-3">
                <label>{{ $lang.nadpis_name }}:</label>
                <input :class="validation.nadpis_name ? 'is-invalid' : ''" v-model="item.nadpis_name" type="text"
                    class="form-control">
                <div class="invalid-feedback">
                    {{ $lang.validation_invalid }}
                </div>
            </div>
            <button class="btn btn-success">{{ $lang.save }}</button>
        </form>
    </div>
</template>
<script>
import panelApi from '../../api/panel-axios.js';
import appConfig from '../../config.js';
export default {
    name: 'nadpisIndex',
    data: function () {
        return {
            item: {
                nadpis_id: null,
                nadpis_name: '',
            },
            validation: {},
        }
    },
    methods: {
        save: function () {
            let vm = this;
            panelApi.post(appConfig.panelApiPrefix + '/nadpis', this.item).then(function (response) {
                vm.$toast(vm.$lang.save_success);
                vm.$router.push('/nadpis');
            }, this.invalidAxios)

        },
        invalidAxios: function (e) {
            if (e.response.status == 422) {
                this.validation = e.response.data.validation;
                this.$toast('Wystąpił błąd', { type: 'error' });
            } else {
                this.$toast('Wystąpił błąd systemu', { type: 'error' });
            }
        }
    },
    mounted() {
        if (!['owner', 'manager'].includes(this.$store.getters['app/role'])) {
            this.$router.push('/');
        }
    }
}
</script>